import { Component, OnDestroy, OnInit } from "@angular/core"
import { CHNode } from "../../models/node.model"
import { BrowsingService } from "../../services/browsing.service"
import { SubjectsComponent } from "../subjects/subjects.component"
import { Subscriber, Subscription } from "rxjs"
import { ColorCodeService } from "../../services/color-code.service"

@Component({
    selector: "app-topics",
    templateUrl: "./topics.component.html",
    styleUrls: ["./topics.component.scss"],
})
export class TopicsComponent implements OnInit, OnDestroy {
    subscriptions: Subscription[] = []
    activeNode: CHNode
    activeTopic: CHNode
    activeSubject: CHNode
    colorCode: string = "#fff"

    constructor(
        private browsingService: BrowsingService,
        private colorCodeService: ColorCodeService
    ) {
        this.colorCode = this.colorCodeService.getPrimaryColor()
    }

    ngOnInit() {
        this.subscriptions.push(
            this.browsingService.activeNodeChanged.subscribe((node) => {
                this.activeNode = node
                this.activeTopic = node.getTopic()
                this.activeSubject = node.getSubject()
                this.colorCode = this.colorCodeService.getColorForNode(node)
            })
        )
    }

    ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
